import { render, staticRenderFns } from "./Bookingreport.vue?vue&type=template&id=31549566&"
import script from "./Bookingreport.vue?vue&type=script&lang=js&"
export * from "./Bookingreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports